import { defaultProps } from 'recompose';
import { GeneLolliplot } from './index';
export default defaultProps({
  geneId: 'ENSG00000134086', // VHL
})(GeneLolliplot);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/Lolliplot/GeneLolliplot.fixture.js